import { useQuery } from '@tanstack/react-query';

import type { InsightsPracticeResponse } from '../@types/contracts';
import { getCurrentDate, getFirstDateOfMonth } from '../utils/date.util';

import { makeAPIRequestReactQuery } from './api';
import { endpoints } from './endpoints';

interface UseGetInsightsPractices {
  organizationId: string;
  startDate: string;
  endDate: string;
  sortBy: string;
  order: string;
  pageSize: number;
  page?: number;
}

const date = getCurrentDate();

export const useGetInsightsPractices = ({
  organizationId,
  startDate = getFirstDateOfMonth(),
  endDate = date,
  sortBy,
  order,
  pageSize,
  page,
}: UseGetInsightsPractices) => {
  const summaryApiPath = `/${endpoints.insights}/${organizationId}/${endpoints.practices}`;

  return useQuery(
    [summaryApiPath, sortBy, order, startDate, endDate, pageSize, page],
    () =>
      makeAPIRequestReactQuery<InsightsPracticeResponse>(summaryApiPath, {
        startDate: startDate,
        endDate: endDate,
        sortBy: sortBy,
        order: order,
        pageSize: pageSize,
        page: page,
      }),
    {
      enabled: !!organizationId,
    },
  );
};
